export const PageHeader = ({ title, subtitle, children }) => (
  <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
    <div>
      <h1 className="font-display text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl" data-testid="page-title">{title}</h1>
      {subtitle && <p className="mt-1 text-sm text-slate-500">{subtitle}</p>}
    </div>
    {children && <div className="flex flex-wrap items-center gap-2">{children}</div>}
  </div>
);

export const StatCard = ({ label, value, testId, accent = "text-slate-900" }) => (
  <div className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm" data-testid={testId}>
    <p className="text-xs font-semibold uppercase tracking-wider text-slate-500">{label}</p>
    <p className={`mt-2 font-display text-3xl font-bold ${accent}`}>{value}</p>
  </div>
);

export const Empty = ({ children, testId }) => (
  <div className="rounded-xl border border-dashed border-slate-300 bg-white p-10 text-center text-sm text-slate-500" data-testid={testId}>{children}</div>
);
